import {
  IframeDataAdaptedType,
  ThreeDSOneAdapted,
  ThreeDSTwoAuthAdapted,
  ThreeDSTwoPayAdapted,
} from '../../../types';

export const isThreeDSTwoAuth = (value: IframeDataAdaptedType): value is ThreeDSTwoAuthAdapted => {
  return value.step === 'threeDS2Auth';
};

export const isThreeDSTwoPay = (value: IframeDataAdaptedType): value is ThreeDSTwoPayAdapted => {
  return value.step === 'threeDS2Pay';
};

export const isThreeDSOne = (value: IframeDataAdaptedType): value is ThreeDSOneAdapted => {
  return value.step === 'threeDS1';
};
